import React, { useEffect, forwardRef, useImperativeHandle } from 'react';
import { useFormik } from 'formik';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const UserScopesForm = forwardRef(({ scopes, formActions, onSubmit }, ref) => {

    // Validation logic
    const validate = (values) => {
        const errors = {};
        if (values.scopes.length === 0) {
            errors.scopes = 'At least one scope is needed';
        }
        return errors;
    };

    // Initial values: map the scopes to checkboxes
    const initialValues = {
        scopes: scopes || [],
    };

    const formik = useFormik({
        initialValues: initialValues,
        validate: validate,
        onSubmit: onSubmit,
    });

    // Handle reset function
    useImperativeHandle(ref, () => ({
        resetForm() {
            formik.handleReset();
        },
    }));

    // Update form values when the parent scope data changes
    useEffect(() => {
        if (scopes) {
            formik.setFieldValue('scopes', scopes);
        }
        // eslint-disable-next-line
    }, [scopes]);

    return (
        <Box component="form" onSubmit={formik.handleSubmit}>
            <Stack direction="column" spacing={2}>
                {/* Scopes Checkbox List */}
                <Box>
                    {['user', 'management', 'admin'].map((scope) => (
                        <FormControlLabel
                            key={scope}
                            control={
                                <Checkbox
                                    checked={formik.values.scopes.includes(scope)}
                                    onChange={formik.handleChange}
                                    name="scopes"
                                    value={scope}
                                    color="primary"
                                />
                            }
                            label={scope.charAt(0).toUpperCase() + scope.slice(1)} // Capitalize scope name
                        />
                    ))}
                </Box>

                {/* Save button */}
                <Box>
                    {formActions()}
                </Box>
            </Stack>
        </Box>
    );
});

export default UserScopesForm;